<template>
    <div class="banner">
        <b-container>
            <b-row>
                <b-col lg="6" class="align-self-center text-left">
                    <div class="txt-header">
                        <span>Con tu <span class="text-gold">Tarjeta Garlan's</span><br>
                            serás recompensado
                        </span>
                        <br>
                        <span class="black-bg">una y otra y otra vez</span>
                    </div>
                    <p class="mb-5 mt-4">La tarjeta para los cachanillas. ¡Aplicar es muy sencillo!, solo necesitas tu dirección, datos de empleo y una identificación.</p>
                    <a href="https://apply.garlans.com/">Aplica hoy</a>
                </b-col>
                <b-col lg="6" class="relative">
                    <img class="img-banner" src="../assets/img/img_card_intro.png" alt="">
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
    export default {

    }
</script>

<style scoped>
.banner{
    margin-top: 110px;
    width: 100%;
    background-image: url('../assets/img/img_intro_bg.jpg');
    background-size: cover;
    background-repeat: no-repeat;
    padding: 10%;
    overflow: hidden;
}
.img-banner{
    position: absolute;
    width: 160%;
    left: -25%;
    top: -40%;
}
.txt-header{
    font-family: futura-pt, sans-serif;
    font-weight: 400;
    font-style: normal;
    color: #fff;
    font-size: 65px;
    line-height: 1.1;
}
.text-gold{
    font-weight: 600;
    color:#F7D85C;
}
.black-bg{
    background: #000;
    padding: 0 5px;
    font-weight: 600;
}
p{
    color: #fff;
    width: 65%;
    font-size: 20px;
}
a,
a:focus,
a:hover{
    color: #fff;
    background: #000;
    text-align: center;
    text-decoration: none;
    padding: 12px 40px;
    font-weight: bold;
    font-size: 25px;
}

@media (max-width: 1600px) {
  .txt-header{
        font-size: 50px;
        line-height: 1.1;
    }
    a,
    a:focus,
    a:hover{
        font-size: 16px;
    }
    p{
        font-size: 14px;
    }
}
@media (min-width: 1741px) {
    .img-banner{
        position: absolute;
        width: 150%;
        left: -25%;
        top: -50%;
    }
}
@media (max-width: 1740px) and (min-width: 1601px) {
    .img-banner{
        position: absolute;
        width: 130%;
        left: -20%;
        top: -30%;
    }
    .txt-header{
        font-size: 55px;
        line-height: 1.1;
    }
}

@media (max-width: 1300px) {
    .img-banner{
        position: relative;
        width: 100%;
        top: 0;
        left: 0;
    }
    .txt-header{
        font-size: 35px;
        line-height: 1.1;
    }
}

@media (max-width: 768px) {
    .img-banner{
        margin-top: 50px;
        position: relative;
        width: 130%;
        left: -20%;
    }
    .banner{
        margin-top: 66px;
        padding: 10% 7%;
    }
    .txt-header{
        font-size: 29px;
        line-height: 1.1;
    }
    p{
        width: 100%;
    }
}


</style>